import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { site } from '../data/site';
import { usePageMeta } from '../components/ScrollToTop';

const privacy = [
  {
    h: 'Information We Collect',
    p: `When you contact TheBigHub through our website, WhatsApp, or email, we collect the information you choose to share — such as your name, business name, email address, phone number, and project details — solely to respond to your inquiry and deliver our services.`,
  },
  {
    h: 'How We Use Your Information',
    p: 'We use your information to communicate with you about your project, provide quotes and services, and improve how we serve you. We do not sell, rent, or share your personal information with third parties for their marketing purposes.',
  },
  {
    h: 'Data Security',
    p: 'We take reasonable measures to protect the information you share with us. Our website is served over a secure connection, and access to personal information is limited to what is necessary to respond to you.',
  },
  {
    h: 'Your Choices',
    p: `You may request access to, correction of, or deletion of your personal information at any time by contacting us at ${site.email} or on WhatsApp at ${site.whatsappDisplay}.`,
  },
];

const terms = [
  {
    h: 'Services',
    p: 'TheBigHub provides digital marketing, creative, technology, and training services as described on this website. Specific deliverables, timelines, and fees for any engagement are agreed with each client in writing before work begins.',
  },
  {
    h: 'Course Pricing & Enrollment',
    p: 'Course prices displayed on this website are current at the time of publication and may be updated. Enrollment is confirmed upon payment. Course access details are shared directly with each enrolled learner.',
  },
  {
    h: 'Intellectual Property',
    p: 'All content on this website — including text, design, and imagery — belongs to TheBigHub unless otherwise stated, and may not be reproduced without permission. Client work remains governed by individual agreements.',
  },
  {
    h: 'No Guaranteed Outcomes',
    p: 'While we work strategically and diligently, digital marketing outcomes depend on many factors. TheBigHub does not guarantee specific sales figures, search rankings, or business results unless explicitly agreed in writing.',
  },
  {
    h: 'Contact',
    p: `Questions about these terms? Reach us at ${site.email} or on WhatsApp at ${site.whatsappDisplay}.`,
  },
];

export default function Legal({ kind }) {
  const isPrivacy = kind === 'privacy';
  const blocks = isPrivacy ? privacy : terms;
  usePageMeta(
    isPrivacy ? 'Privacy Policy — TheBigHub' : 'Terms & Conditions — TheBigHub',
    isPrivacy
      ? 'How TheBigHub collects, uses, and protects your personal information.'
      : 'The terms that govern TheBigHub\u2019s services, courses, and website.'
  );
  return (
    <main data-testid={`${kind}-page`}>
      <PageHero
        eyebrow={isPrivacy ? 'Privacy Policy' : 'Terms & Conditions'}
        title={isPrivacy ? 'Your Privacy, Respected.' : 'Clear Terms. Honest Work.'}
        copy={`Last updated: July 2026 · Questions? Email ${site.email}`}
      />
      <section className="bg-cream">
        <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-24">
          {blocks.map((b, i) => (
            <Reveal key={b.h} delay={i * 0.05}>
              <div className="mb-8 rounded-2xl border-2 border-forest bg-forest p-7 sm:p-9">
                <h2 className="font-display text-xl font-bold text-white">
                  <span className="mr-3 font-mono text-sm text-goldlight">0{i + 1}</span>
                  {b.h}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-white">{b.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
